import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Dropdown, Spinner } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import ModalEntityViewer from '../../../components/Modals/ModalEntityViewer';
import ModalList from '../../../components/Modals/ModalList';
import { toast } from 'react-toastify';
import { Button, Modal, Table } from 'react-bootstrap';
import { LanguageProvider } from '../../../core/language-provider';



export default function DGLTH_item_model({ item, entity = null }) {

    const navigate = useNavigate();

    const [statusModalListStorico, setStatusModalListStorico] = useState(false)
    const [statusModalListFornitori, setStatusModalListFornitori] = useState(false)
    const searchObjStorico = {
        'query': '',
        'fields': [],
        'constraints': [
            { fieldName: "idItemModel", type: "value", value: item ? item.id : null }
        ]
    }
    const searchObjFornitori = {
        'query': '',
        'fields': [],
        'constraints': [
            { fieldName: "itemCode", type: "value", value: item ? item.code : null }
        ]
    }

    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [data, setData] = useState(false);
    const [itemModel, setItemModel] = useState(false);

    const [loadingDimensions, setLoadingDimensions] = useState(false);
    const [showDimensions, setShowDimensions] = useState(false);
    const [dimensionsData, setDimensionsData] = useState(null);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleCloseDimensions = () => setShowDimensions(false);
    const handleShowDimensions = () => setShowDimensions(true);


    
    async function loadImplosione(item) {
        setLoading(true)
        handleShow()
        setItemModel(item)
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var constraints = [
            { fieldName: "idItemModel", type: "value", value: item.id }
        ]
        var response = await DataManager.searchItems('mp_children', 1, 20, sorting, '', [], constraints);
        console.log(response)
        if (response.success === 1) {
            setData(response.body);
            setLoading(false)
        } else {
            toast.error("Errore nell'implosione.", { theme: 'colored' })
            setLoading(false)
            handleClose()
        }
    }
    async function openDistintaImplosione(id) {
        var sorting = {
            'field': 'id',
            'order': 'asc'
        }
        var constraints = [
            { fieldName: "idItemModel", type: "value", value: id }
        ]
        var response = await DataManager.searchItemsSimple('manufacturing_process_model', 1, 20, sorting, '', [], constraints);
        console.warn('RESPONSE', response);
        if (response.success === 1 && response.body.length) {
            var idMpm = response.body[0].id
            navigate('/page/MpmTree2?id=' + idMpm)
        }
        else {
            toast.error('Distinta non trovata', { theme: 'colored' })
        }
    }
    async function openDistinta() {
        var sorting = {
            'field': 'id',
            'order': 'asc'
        }
        var constraints = [
            { fieldName: "idItemModel", type: "value", value: item.id }
        ]
        var response = await DataManager.searchItemsSimple('manufacturing_process_model', 1, 20, sorting, '', [], constraints);
        console.warn('RESPONSE', response);
        if (response.success === 1 && response.body.length) {
            var idMpm = response.body[0].id
            //navigate('/page/MpmTree?id=' + idMpm)
            window.open('/page/MpmTree2?id=' + idMpm)
        }
        else {
            toast.error('Distinta non trovata', { theme: 'colored' })
        }
    }



    function closeModalListStorico() {
        setStatusModalListStorico(false)
    }

    function openModalListStorico() {
        setStatusModalListStorico(true);
    }
    function closeModalListFornitori() {
        setStatusModalListFornitori(false)
    }

    function openModalListFornitori() {
        setStatusModalListFornitori(true);
    }

    async function loadDimensioniFigli(item) {
        // Verifica se l'articolo è di picking
        if (item.picking !== 1) {
            toast.error("Questo articolo non è di picking. Le dimensioni figli sono disponibili solo per articoli di picking.", { theme: 'colored' });
            return;
        }

        setLoadingDimensions(true);
        handleShowDimensions();
        setItemModel(item);

        try {
            // Recupera il manufacturing_process_model dell'articolo
            var sorting = {
                'field': 'id',
                'order': 'desc'
            };
            var constraints = [
                { fieldName: "idItemModel", type: "value", value: item.id }
            ];
            var response = await DataManager.searchItems('manufacturing_process_model', 1, 1, sorting, '', [], constraints);

            if (response.success === 1 && response.body.length > 0 && response.body[0].children) {
                const children = response.body[0].children;

                // Calcola i totali
                let totalPackages = 0;
                let totalGrossWeight = 0;
                let totalVolume = 0;

                const childrenDetails = [];

                for (const child of children) {
                    const childItem = child.idItemModel;
                    if (childItem) {
                        const quantity = parseFloat(child.quantity) || 0;
                        const packages = parseFloat(childItem.packages) || 0;
                        const grossWeight = parseFloat(childItem.grossWeight) || 0;
                        const volume = parseFloat(childItem.volume) || 0;

                        const childPackages = packages * quantity;
                        const childGrossWeight = grossWeight * quantity;
                        const childVolume = volume * quantity;

                        totalPackages += childPackages;
                        totalGrossWeight += childGrossWeight;
                        totalVolume += childVolume;

                        childrenDetails.push({
                            code: childItem.code,
                            name: childItem.name,
                            quantity: quantity,
                            packages: packages,
                            grossWeight: grossWeight,
                            volume: volume,
                            totalPackages: childPackages,
                            totalGrossWeight: childGrossWeight,
                            totalVolume: childVolume
                        });
                    }
                }

                setDimensionsData({
                    children: childrenDetails,
                    totalPackages: totalPackages,
                    totalGrossWeight: totalGrossWeight,
                    totalVolume: totalVolume
                });
                setLoadingDimensions(false);
            } else {
                toast.error("Errore nel caricamento delle dimensioni figli. La distinta base non è stata trovata.", { theme: 'colored' });
                setLoadingDimensions(false);
                handleCloseDimensions();
            }
        } catch (error) {
            console.error("Errore nel caricamento delle dimensioni figli:", error);
            toast.error("Errore nel caricamento delle dimensioni figli.", { theme: 'colored' });
            setLoadingDimensions(false);
            handleCloseDimensions();
        }
    }


    return (
        <>

            <Dropdown>
                <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic" size='sm'>
                    Azioni
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => openDistinta()}>Distinta</Dropdown.Item>
                    <Dropdown.Item onClick={() => openModalListStorico()}>Storico movimentazioni</Dropdown.Item>
                    <Dropdown.Item onClick={() => openModalListFornitori()}>Listino fornitori</Dropdown.Item>
                    <Dropdown.Item onClick={() => navigate('/page/BindellaItemModel?id=' + item.id)}>Stampa bindella</Dropdown.Item>
                    <Dropdown.Item onClick={() => loadImplosione(item)}>Implosione</Dropdown.Item>
                    <Dropdown.Item onClick={() => loadDimensioniFigli(item)}>Dimensioni figli</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>

            {statusModalListStorico && (
                <ModalList entity={'item_model_movement'} searchObj={searchObjStorico} closeModal={closeModalListStorico} status={statusModalListStorico} />
            )}

            {statusModalListFornitori && (
                <ModalList entity={'gyv_all_supplier_item'} searchObj={searchObjFornitori} closeModal={closeModalListFornitori} status={statusModalListFornitori} />
            )}


            <Modal show={show} onHide={handleClose} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Implosione articolo: {itemModel.code}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? <>
                        <div className='text-center p-5'>
                            <Spinner animation="border" variant="primary" />
                            <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                        </div>
                    </> : <>
                        <Table responsive striped>
                            <thead>
                                <tr>
                                    <th>Codice</th>
                                    <th>Descrizione</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.map((item, i) => {
                                    return (<>
                                        <tr key={i}>
                                            <td>{item.idMP.idItemModel.code}</td>
                                            <td>{item.idMP.idItemModel.name}</td>
                                            <td><Button onClick={() => { openDistintaImplosione(item.idMP.idItemModel.id) }} size='sm'>Vai a Distinta Base</Button></td>
                                        </tr>
                                    </>)
                                })}
                            </tbody>
                        </Table>
                        {data && data.length === 0 ? <>
                            <Alert variant='warning'>Questo articolo non è presente in nessuna distainta base.</Alert>
                        </> : null}
                    </>}

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDimensions} onHide={handleCloseDimensions} size='xl'>
                <Modal.Header closeButton>
                    <Modal.Title>Dimensioni figli articolo: {itemModel.code}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loadingDimensions ? <>
                        <div className='text-center p-5'>
                            <Spinner animation="border" variant="primary" />
                            <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                        </div>
                    </> : <>
                        {dimensionsData && dimensionsData.children && dimensionsData.children.length > 0 ? <>
                            <Alert variant='info' className='mb-3'>
                                <strong>Totali aggregati:</strong>
                                <ul className='mb-0 mt-2'>
                                    <li><strong>Colli totali:</strong> {dimensionsData.totalPackages.toFixed(2)}</li>
                                    <li><strong>Peso lordo totale:</strong> {dimensionsData.totalGrossWeight.toFixed(2)} kg</li>
                                    <li><strong>Volume totale:</strong> {dimensionsData.totalVolume.toFixed(4)} mc</li>
                                </ul>
                            </Alert>

                            <Table responsive striped>
                                <thead>
                                    <tr>
                                        <th>Codice</th>
                                        <th>Descrizione</th>
                                        <th className='text-end'>Quantità</th>
                                        <th className='text-end'>Colli unitari</th>
                                        <th className='text-end'>Peso lordo (kg)</th>
                                        <th className='text-end'>Volume (mc)</th>
                                        <th className='text-end'>Colli totali</th>
                                        <th className='text-end'>Peso totale (kg)</th>
                                        <th className='text-end'>Volume totale (mc)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dimensionsData.children.map((child, i) => {
                                        return (
                                            <tr key={i}>
                                                <td>{child.code}</td>
                                                <td>{child.name}</td>
                                                <td className='text-end'>{child.quantity}</td>
                                                <td className='text-end'>{child.packages.toFixed(2)}</td>
                                                <td className='text-end'>{child.grossWeight.toFixed(2)}</td>
                                                <td className='text-end'>{child.volume.toFixed(4)}</td>
                                                <td className='text-end'><strong>{child.totalPackages.toFixed(2)}</strong></td>
                                                <td className='text-end'><strong>{child.totalGrossWeight.toFixed(2)}</strong></td>
                                                <td className='text-end'><strong>{child.totalVolume.toFixed(4)}</strong></td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </> : <>
                            <Alert variant='warning'>Questo articolo non ha figli configurati.</Alert>
                        </>}
                    </>}

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDimensions}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    )
};